import Api from '@/utils/api';
import i18n from '@/utils/i18n';
import _ from 'lodash';

export default class Datasource {
  constructor(namespace, args) {
    this.namespace = namespace;
    this.loading = false;
    this.labelNamespace = (args.labelNamespace || this.namespace).replace(
      '/',
      '',
    );
    this.pagination = {
      page: args.page || null,
      rowsPerPage: args.rowsPerPage || null,
      sortBy: Array.isArray(args.sortBy) ? args.sortBy : [args.sortBy],
      descending: Array.isArray(args.descending)
        ? args.descending
        : [args.descending],
    };
    this.args = args.args || {};
    this.body = args.body || null;
    this.dense = args.dense || true;
    this.items = args.items || [];
    this.totalRows = args.totalRows || 0;
    this.totalSubRows = args.totalSubRows || 0;
    this.selectAll = args.selectAll;
    this.customRowClass = args.customRowClass;
    this.linkClass = args.linkClass;

    this.fields = args.fields
      ? args.fields.map(f => {
          if (typeof f === 'string') {
            return this.addDefaultClasses({
              value: f,
            });
          } else {
            return this.addDefaultClasses(f);
          }
        })
      : undefined;
    this.debouncedRefresh = _.debounce(this.refresh, 200);
  }

  addDefaultClasses(field) {
    if (field.value === '_select') {
      field.icon = 'edit';
    } else if (field.value === '_add') {
      field.icon = 'add';
    } else if (field.value === '_link') {
      field.icon = 'link';
    } else if (field.value === '_alarms') {
      field.icon = 'warning';
    } else if (field.value === '_delete') {
      field.icon = 'delete';
    }

    if (field.icon) {
      field.sortable = false;
      field.width = '20px';
    } else if (field.particular) {
      return field;
    } else {
      if (!field.text) {
        field.text = i18n.t(this.labelNamespace + '.headers.' + field.value);
      }
    }
    return field;
  }

  linkTo(linkProperties) {
    var item = linkProperties.item;
    var linkId = linkProperties.linkId;
    var linkUrl = linkProperties.linkUrl;
    return {
      name: linkUrl ? linkUrl : this.namespace + '/detail',
      params: {
        id: linkId ? linkId : item.id,
      },
    };
  }

  selecteds() {
    return this.items.filter(item => item.selected);
  }

  selectedsCount() {
    return this.selecteds().length;
  }

  noneSelecteds() {
    return !this.hasSelecteds();
  }

  hasSelecteds() {
    return this.selectedsCount() > 0;
  }

  clear() {
    this.pagination.page = 1;
    this.items = [];
    this.totalRows = 0;
  }

  refresh() {
    if (!this.namespace) {
      return;
    }

    const me = this;
    const input = {
      params: {
        ...this.args,
        page: this.pagination.page ? this.pagination.page - 1 : null,
        size: this.pagination.rowsPerPage,
      },
    };

    if (this.pagination.sortBy && this.pagination.sortBy.length) {
      const mapped = this.pagination.sortBy.map(
        (by, i) => by + ',' + (this.pagination.descending[i] ? 'DESC' : 'ASC'),
      );
      input.params.sort = mapped[0];
    }

    input.before = function(request) {
      // abort previous request, if exists
      if (this.previousRequest) {
        this.previousRequest.abort();
        this.previousRequest = null;
      }

      // set previous request on Vue instance
      this.previousRequest = request;
    };

    // FIXME gestion de l'annulation
    this.loading = true;
    const api = new Api(this.namespace);
    const body = this.body;
    const promise = body === null ? api.get(input) : api.post(body, input);
    return promise
      .then(response => {
        const rbody = response.body;
        me.items = rbody.items;
        me.totalRows = rbody.totalRows;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
